import Keycloak from 'keycloak-js';
import moment from 'moment';
import { jwtDecode } from "jwt-decode";


const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL,
  realm: process.env.REACT_APP_KEYCLOAK_REALM,
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID
};

let keycloakInstance = null;

const KeycloakManager = () => {
  if (!keycloakInstance) {
    keycloakInstance = new Keycloak(keycloakConfig);
  }

  const initialize = async () => {
    let isLogin = false;
    let token = null;
    let loading = true;

    console.log('initializing...')
    try {
      const authenticated = await keycloakInstance.init({
        onLoad: 'login-required',
      });

      if (authenticated) {
        isLogin = true;
        token = keycloakInstance.token;

        localStorage.setItem('token', `Bearer ${keycloakInstance.token}`);
        localStorage.setItem('refreshToken', `${keycloakInstance.refreshToken}`);

        const accessTokenExpiry = moment(keycloakInstance?.tokenParsed?.exp * 1000).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss');
        // const refreshTokenExpiry = moment(keycloakInstance?.refreshTokenParsed?.exp * 1000).tz('Asia/Kolkata').format('YYYY-MM-DD HH:mm:ss');

        localStorage.setItem('accessTokenExpiry', accessTokenExpiry);
        const decodedToken = jwtDecode(token);
        localStorage.setItem("decodedToken", JSON.stringify(decodedToken));
        // localStorage.setItem('refreshTokenExpiry', refreshTokenExpiry);
      } else {
        console.error('Authentication failed');
      }
    } catch (err) {
      console.error('Failed to initialize Keycloak:', err);
    } finally {
      loading = false;
    }

    return { isLogin, token, loading };
  };

  const logout = () => {
    if (keycloakInstance) {
      keycloakInstance.logout({}).then(() => {
        localStorage.clear();
      }).catch(err => {
        console.log('Logout failed:', err);
        localStorage.clear();
      });
    } else {
      console.log('Keycloak instance is not initialized');
      localStorage.clear();
    }
  };
  return { initialize, logout };
};

export default KeycloakManager;
